import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { EcdStates } from '../../root/ecd-model';
import { getEcdEpiProps, setParishSettingsProps } from '../ducks/epi-api';
import { EcdRootPage } from '../models/ecd-page-models';
import { EcdParishSettingsProps } from '../models/epi-model';

export function useEpiParishSettingsLoaded() : boolean {
    return useSelector<EcdStates, boolean>(state => state.epiProps?.parishSettingsState?.parishSettingsLoaded);
}

export function useEpiParishSettings() : EcdParishSettingsProps {

    const ecdParishPageContentId: string = (useSelector<EcdStates, any>(state => state.epiProps?.contentState?.epiContent) as EcdRootPage)?.parishSettingId;
    const language = useSelector<EcdStates, string>(state => state.globalization?.currentlanguage);
    const stateData = useSelector<EcdStates, EcdParishSettingsProps>(state => state.epiProps?.parishSettingsState?.parishSettings);
    const contentLoaded = useEpiParishSettingsLoaded();    

    const dispatch = useDispatch();

    useEffect(() => {
        if (!contentLoaded && ecdParishPageContentId){
            dispatch(getEcdEpiProps(dispatch, ecdParishPageContentId, {}, language, false, setParishSettingsProps));
        }
    }, [contentLoaded, ecdParishPageContentId]);

    return stateData;
}